import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  AccountBalance as BankIcon,
  Receipt as TransactionIcon,
  CurrencyBitcoin as CryptoIcon,
  Notifications as NotificationIcon,
  Support as SupportIcon,
  CardGiftcard as RewardIcon,
  ElectricBolt as SolarIcon,
  Payments as PaymentsIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ onClose }) => {
  const navigate = useNavigate();

  const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/admin/dashboard" },
    { text: "Users Management", icon: <PeopleIcon />, path: "/admin/users" },
    { text: "Banks Listing", icon: <BankIcon />, path: "/admin/banks" },
    {
      text: " Crypto Transactions",
      icon: <TransactionIcon />,
      path: "/admin/transactions",
    },
    {
      text: "Bank Transactions",
      icon: <PaymentsIcon />,
      path: "/admin/bank-transactions",
    },
    { text: "Crypto Listing", icon: <CryptoIcon />, path: "/admin/crypto" },
    {
      text: " Broadcast Notifications",
      icon: <NotificationIcon />,
      path: "/admin/notifications",
    },
    { text: "Support", icon: <SupportIcon />, path: "/admin/support" },
    { text: "Rewards Settings", icon: <RewardIcon />, path: "/admin/rewards" },
    { text: "Solar Program", icon: <SolarIcon />, path: "/admin/solar" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  return (
    <List>
      {menuItems.map((item) => (
        <ListItem
          button
          key={item.text}
          onClick={() => handleNavigation(item.path)}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
      <Divider />
    </List>
  );
};

export default Sidebar;
